import { NavItem, Nav } from 'reactstrap';
import { useLocation, Link } from "react-router-dom";
import './Sidebar.css'

function Sidebar({ branch }) {
    const location = useLocation();
    return (
        <div className="vms-sidebar">
            <Nav vertical>
                <NavItem className={location.pathname === `/admin` ? "active" : ""}>
                    <Link className="nav-link" to={`/admin#${branch}`}><i className="fa fa-line-chart" aria-hidden="true"></i><label>&nbsp;&nbsp;&nbsp;Overview</label></Link>
                </NavItem>
                <NavItem className={location.pathname === `/admin/tickets` ? "active" : ""}>
                    <Link className="nav-link" to={`/admin/tickets#${branch}`}><i className="fa fa-users" aria-hidden="true"></i><label>&nbsp;&nbsp;&nbsp;Tickets</label></Link>
                </NavItem>
                <NavItem className={location.pathname === `/admin/agents` ? "active" : ""}>
                    <Link className="nav-link" to={`/admin/agents#${branch}`}><i className="fa fa-user-circle" aria-hidden="true"></i><label>&nbsp;&nbsp;&nbsp;Agents</label></Link>
                </NavItem>
                <NavItem className={location.pathname === `/admin/languages` ? "active" : ""}>
                    <Link className="nav-link" to={`/admin/languages#${branch}`}><i className="fa fa-language" aria-hidden="true"></i><label>&nbsp;&nbsp;&nbsp;Languages</label></Link>
                </NavItem>
                <NavItem className={location.pathname === `/admin/locations` ? "active" : ""}>
                    <Link className="nav-link" to={`/admin/locations#${branch}`}><i className="fa fa-map-marker" aria-hidden="true"></i><label>&nbsp;&nbsp;&nbsp;Locations</label></Link>
                </NavItem>
                <NavItem className={location.pathname === `/admin/queues` ? "active" : ""}>
                    <Link className="nav-link" to={`/admin/queues#${branch}`}><i className="fa fa-code-fork" aria-hidden="true"></i><label>&nbsp;&nbsp;&nbsp;Queues</label></Link>
                </NavItem>
                <NavItem className={location.pathname === `/admin/reasons` ? "active" : ""}>
                    <Link className="nav-link" to={`/admin/reasons#${branch}`}><i className="fa fa-building-o" aria-hidden="true"></i><label>&nbsp;&nbsp;&nbsp;Reasons</label></Link>
                </NavItem>
                <NavItem className={location.pathname === `/admin/settings` ? "active" : ""}>
                    <Link className="nav-link" to={`/admin/settings#${branch}`}><i className="fa fa-cog" aria-hidden="true"></i><label>&nbsp;&nbsp;&nbsp;Settings</label></Link>
                </NavItem>
            </Nav>
        </div>
    )
}

export default Sidebar
